// extracted by mini-css-extract-plugin
module.exports = {"we":"recruitment_we__1h_IA","shadow_btn":"recruitment_shadow_btn__sZvMx"};